import * as React from 'react';
import { connect } from 'react-redux';
import * as ReactDOM from 'react-dom';
import { Route, Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";
import InlineTextDisplay from '../Controls/InlineTextDisplay';


class Mission extends React.Component<any, any> {

    render() {
        let content = <div></div>;

        if (this.props.aboutUsSettings && !this.props.isLoading) {
            //content = (<div className="content" dangerouslySetInnerHTML={{
            //    __html: this.props.aboutUsSettings.missionHtmlText
            //}}></div>);
            content = <InlineTextDisplay source={this.props.aboutUsSettings.missionHtmlText} />
        }

        return content;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        aboutUsSettings: state.siteData.siteData.aboutUsSettings,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const MissionContainer = connect(mapStateToProps, mapDispatchToProps)(
    Mission
);

export default MissionContainer;


// WEBPACK FOOTER //
// ./src/components/AboutUs/Mission.tsx